/**
 * Creates a "class" constructor from the passed descriptor object.
 *
 * Not all target browsers support ES2015 class syntax so we need a helper.
 *
 * @function Class
 * @param {Object} descriptor - An object describing the class.
 * @param {function} [descriptor.constructor] - A function to be the constructor 
 * of the class
 * @param {function} [descriptor.*] - A class method.
 * @param {function} [descriptor.get__*] - A function to use as a getter for a 
 * property.
 * @param {function} [descriptor.set__*] - A function to use as a setting for a 
 * property.
 * @param {function} [descriptor.static__*] - A static function on the class.
 * @return {Function} - A new class constructor.
 */
export var Class = function(descriptor){
	var constructor = descriptor.constructor || function(){};
	var prototype = {};

	if (descriptor.extends){
		var parent = descriptor.extends;
		var originalConstructor = constructor;

		constructor = function(){
			parent.apply(this, arguments);
			originalConstructor.apply(this, arguments);
		};

		var proto = function(){};
		proto.prototype = parent.prototype;
		prototype = new proto();
	}

	var getterSetters = {}

	var name
	for (var key in descriptor) if (descriptor.hasOwnProperty(key)){
		if (key === 'constructor') continue;
		if (key === 'extends') continue;

		if (key.slice(0, 5) === 'get__'){
			name = key.slice(5);
			getterSetters[name] = getterSetters[name] || {};
			getterSetters[name].getter = descriptor[key];
			continue;
		}

		if (key.slice(0, 5) === 'set__'){
			name = key.slice(5);
			getterSetters[name] = getterSetters[name] || {};
			getterSetters[name].setter = descriptor[key];
			continue;
		}

		if (key.slice(0, 8) === 'static__'){
			name = key.slice(8);
			constructor[name] = descriptor[key];
			continue;
		}

		prototype[key] = descriptor[key];
	}

	for (var key in getterSetters) if (getterSetters.hasOwnProperty(key)){
		var opts = {
			enumerable: true,
			configurable: true
		};
		if (getterSetters[key].getter) opts.get = getterSetters[key].getter;
		if (getterSetters[key].setter) opts.set = getterSetters[key].setter;
		Object.defineProperty(prototype, key, opts);
	}

	constructor.prototype = prototype;

	return constructor;
};